import { FC } from 'react';

import {
    BoxSVGIcon,
    CodaSVGIcon,
    ConfluenceSVGIcon,
    DocuSignSVGIcon,
    DropboxSVGIcon,
    GoogleDriveSVGIcon,
    GoogleSheetsSVGIcon,
    MiroSVGIcon,
    NotionSVGIcon,
    SlackSVGIcon,
    SmartsheetSVGIcon,
} from '@/assets';
import SearchFilterCheckboxList, {
    type SearchFilterCheckboxOption,
} from '@/shared/components/filters/SearchFilterCheckboxList';

interface SourcesProps {
    filters: Record<string, unknown>;
    handleChange: (path: string[], value: unknown) => void;
}

const sourceOptions: SearchFilterCheckboxOption[] = [
    { label: 'SEC', value: 'sec' },
    { label: 'Platform Financials', value: 'platformFinancials' },
    { avatar: { src: BoxSVGIcon }, label: 'Box', value: 'box' },
    { avatar: { src: CodaSVGIcon }, label: 'Coda', value: 'coda' },
    { avatar: { src: ConfluenceSVGIcon }, label: 'Confluence', value: 'confluence' },
    { avatar: { src: DocuSignSVGIcon }, label: 'DocuSign', value: 'docusign' },
    { avatar: { src: DropboxSVGIcon }, label: 'Dropbox', value: 'dropbox' },
    { avatar: { src: GoogleDriveSVGIcon }, label: 'Google Drive', value: 'googleDrive' },
    { avatar: { src: GoogleSheetsSVGIcon }, label: 'Google Sheets', value: 'googleSheets' },
    { avatar: { src: MiroSVGIcon }, label: 'Miro', value: 'miro' },
    { avatar: { src: NotionSVGIcon }, label: 'Notion', value: 'notion' },
    { avatar: { src: SlackSVGIcon }, label: 'Slack', value: 'slack' },
    { avatar: { src: SmartsheetSVGIcon }, label: 'Smartsheet', value: 'smartsheet' },
];

const Sources: FC<SourcesProps> = ({ filters, handleChange }): JSX.Element => (
    <SearchFilterCheckboxList
        onChange={(value) => handleChange(['sources'], value)}
        options={sourceOptions}
        value={Array.isArray(filters.sources) ? filters.sources.map(String) : []}
    />
);

export default Sources;
